function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-performers_svg__a",
  x1: "50%",
  x2: "43.492%",
  y1: "-17.805%",
  y2: "40.861%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-performers_svg__c",
  x1: "50%",
  x2: "43.492%",
  y1: "-18.869%",
  y2: "40.718%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2A8F9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2A8F9D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-performers_svg__e",
  x1: "50%",
  x2: "43.492%",
  y1: "-18.869%",
  y2: "40.718%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#285D99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#285D99",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-performers_svg__g",
  x1: "50%",
  x2: "43.492%",
  y1: "-18.869%",
  y2: "40.718%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2C439C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2C439C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "top-performers_svg__i",
  x1: "50%",
  x2: "43.492%",
  y1: "-18.869%",
  y2: "40.718%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#582398"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#582398",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "top-performers_svg__b",
  width: "109.3%",
  height: "109.4%",
  x: "-4.7%",
  y: "-4.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2
})), /*#__PURE__*/React.createElement("filter", {
  id: "top-performers_svg__d",
  width: "115.2%",
  height: "115.2%",
  x: "-7.6%",
  y: "-7.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2
})), /*#__PURE__*/React.createElement("filter", {
  id: "top-performers_svg__f",
  width: "127.3%",
  height: "127.3%",
  x: "-13.6%",
  y: "-13.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2
})), /*#__PURE__*/React.createElement("filter", {
  id: "top-performers_svg__h",
  width: "144.4%",
  height: "144.4%",
  x: "-22.2%",
  y: "-22.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2
})), /*#__PURE__*/React.createElement("filter", {
  id: "top-performers_svg__j",
  width: "180%",
  height: "180%",
  x: "-40%",
  y: "-40%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 2
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "top-performers_svg__k",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%",
  gradientTransform: "matrix(0 1 -.99225 0 .583 -.416)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "43.848%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "top-performers_svg__l",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "43.848%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "top-performers_svg__m",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%",
  gradientTransform: "matrix(0 1 -.97727 0 .582 -.416)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "43.848%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "top-performers_svg__n",
  cx: "50%",
  cy: "8.396%",
  r: "83.448%",
  fx: "50%",
  fy: "8.396%",
  gradientTransform: "matrix(0 1 -.93333 0 .578 -.416)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "43.848%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.986%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 314.5,
  cy: 191,
  fill: "url(#top-performers_svg__a)",
  filter: "url(#top-performers_svg__b)",
  opacity: 0.349,
  rx: 64.5,
  ry: 64
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188.5,
  cy: 166.5,
  r: 39.5,
  fill: "url(#top-performers_svg__c)",
  filter: "url(#top-performers_svg__d)",
  opacity: 0.687
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 149,
  r: 22,
  fill: "url(#top-performers_svg__e)",
  filter: "url(#top-performers_svg__f)",
  opacity: 0.843
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 140.5,
  r: 13.5,
  fill: "url(#top-performers_svg__g)",
  filter: "url(#top-performers_svg__h)",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 134.5,
  r: 7.5,
  fill: "url(#top-performers_svg__i)",
  filter: "url(#top-performers_svg__j)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 314.5,
  cy: 64,
  fill: "#23C386",
  rx: 64.5,
  ry: 64
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188.5,
  cy: 88.5,
  r: 39.5,
  fill: "#00919F"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 106,
  cy: 106.5,
  fill: "#205C9D",
  rx: 22,
  ry: 21.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 314.5,
  cy: 64,
  fill: "url(#top-performers_svg__k)",
  opacity: 0.343,
  rx: 64.5,
  ry: 64
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188.5,
  cy: 88.5,
  r: 39.5,
  fill: "url(#top-performers_svg__l)",
  opacity: 0.343
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 106,
  cy: 106.5,
  fill: "url(#top-performers_svg__m)",
  opacity: 0.343,
  rx: 22,
  ry: 21.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 114.5,
  r: 13.5,
  fill: "#332A9B"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.5,
  cy: 121,
  fill: "#742097",
  rx: 7.5,
  ry: 7
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.5,
  cy: 114.5,
  r: 13.5,
  fill: "url(#top-performers_svg__l)",
  opacity: 0.343
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.5,
  cy: 121,
  fill: "url(#top-performers_svg__n)",
  opacity: 0.343,
  rx: 7.5,
  ry: 7
}));

function SvgTopPerformers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385 189"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgTopPerformers as ReactComponent };